import React from 'react';
import Button from '@mui/material/Button';
import { useTranslate } from 'react-admin';
import { darken } from '@mui/material/styles';

import EveryIcon from '../icons/EveryIcon';

const sx = {
    backgroundColor: '#3A846B',
    color: '#FFF',
    textTransform: 'inherit',
    '& svg': {
        marginRight: '5px'
    },
    '&:hover': {
        backgroundColor: darken('#3A846B', 0.25)
    }
};

const DonateButton = () => {
    const translate = useTranslate();

    return (
        <Button
            color="success"
            variant="contained"
            target="_blank"
            href="https://www.every.org/liberation-route-europe?utm_campaign=donate-link&method=bank%2Ccard%2Cgift%2Cpaypal%2Cpay%2Cvenmo#/donate"
            sx={sx}
        >
            <EveryIcon />
            {translate('Donate')}
        </Button>
    );
};

export default DonateButton;